import { render, staticRenderFns } from "./AudioBlock.vue?vue&type=template&id=26c22ba0&"
import script from "./AudioBlock.vue?vue&type=script&lang=js&"
export * from "./AudioBlock.vue?vue&type=script&lang=js&"
import style0 from "./AudioBlock.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!C:/wamp64/www/annabratus.com/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFlex } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
installComponents(component, {VFlex,VLayout})
